export default {
  Name: 'Назва',
  'Storage type': 'Тип',
};
